(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-c_featured-blog-list]';
  const SR_TARGET_SELECTOR = '[data-sr-target]';
  const LOG_PREFIX = '[c_featured-blog-list]';

  const sectionCache = new Map();
  const initializedSections = new WeakSet();

  function buildSrUrl(sectionEl) {
    const blogHandle = sectionEl.dataset.blogHandle;
    const tagHandle = sectionEl.dataset.tagHandle;
    const sectionId = sectionEl.dataset.sectionId;

    if (!blogHandle || !tagHandle || !sectionId) {
      return null;
    }

    return `/blogs/${blogHandle}/tagged/${tagHandle}?section_id=${sectionId}`;
  }

  function getCacheKey(sectionEl) {
    return [
      sectionEl.dataset.sectionId,
      sectionEl.dataset.filterTag,
      sectionEl.dataset.tagHandle,
      sectionEl.dataset.articlesCount,
      sectionEl.dataset.blogHandle,
      sectionEl.dataset.blocksKey,
    ].join('|');
  }

  async function fetchSectionHtml(sectionEl) {
    const url = buildSrUrl(sectionEl);
    if (!url) {
      return null;
    }

    const cacheKey = getCacheKey(sectionEl);
    if (sectionCache.has(cacheKey)) {
      return sectionCache.get(cacheKey);
    }

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Section render failed: ${response.status}`);
    }

    const html = await response.text();
    sectionCache.set(cacheKey, html);
    return html;
  }

  function extractSrTarget(html, sectionId) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const sectionRoot =
      doc.getElementById(`shopify-section-${sectionId}`) ||
      doc.querySelector(`#shopify-section-${sectionId}`);

    if (!sectionRoot) {
      return null;
    }

    return sectionRoot.querySelector(SR_TARGET_SELECTOR);
  }

  async function refreshViaSr(sectionEl) {
    const sectionId = sectionEl.dataset.sectionId;
    const target = sectionEl.querySelector(SR_TARGET_SELECTOR);

    if (!sectionId || !target) {
      return;
    }

    try {
      const html = await fetchSectionHtml(sectionEl);
      if (!html) {
        return;
      }

      const newTarget = extractSrTarget(html, sectionId);
      if (!newTarget) {
        throw new Error('SR target not found in response');
      }

      target.replaceWith(newTarget);
    } catch (error) {
      console.error(LOG_PREFIX, 'Failed to refresh section', error);
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl || initializedSections.has(sectionEl)) {
      return;
    }

    initializedSections.add(sectionEl);
  }

  function initAll(root = document) {
    root.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function handleSectionLoad(event) {
    const sectionRoot = event.target.querySelector(SECTION_SELECTOR);
    if (!sectionRoot) {
      return;
    }

    sectionCache.delete(getCacheKey(sectionRoot));
    initializedSections.delete(sectionRoot);
    initSection(sectionRoot);
    refreshViaSr(sectionRoot);
  }

  function handleSectionUnload(event) {
    const sectionRoot = event.target.querySelector(SECTION_SELECTOR);
    if (!sectionRoot) {
      return;
    }

    sectionCache.delete(getCacheKey(sectionRoot));
    initializedSections.delete(sectionRoot);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAll();
  });

  document.addEventListener('shopify:section:load', handleSectionLoad);
  document.addEventListener('shopify:section:unload', handleSectionUnload);

  if (document.readyState !== 'loading') {
    initAll();
  }
})();
